module.exports = __webpack_public_path__ + "static/battle_12-95d12f2dcd131e9090d610278d9d3ab6.jpg";